var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_851_6742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.851 4.16602H10.8847V15.8327H17.851C18.0904 15.8327 18.2864 15.6452 18.2864 15.416V4.58268C18.2864 4.35352 18.0904 4.16602 17.851 4.16602Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9325 6.25H16.9802V7.5H13.9325V6.25ZM13.9325 10.4167H16.9802V11.6667H13.9325V10.4167ZM13.9325 12.5H16.9802V13.75H13.9325V12.5ZM13.9325 8.33333H16.9802V9.58333H13.9325V8.33333ZM10.8847 6.25H13.0617V7.5H10.8847V6.25ZM10.8847 10.4167H13.0617V11.6667H10.8847V10.4167ZM10.8847 12.5H13.0617V13.75H10.8847V12.5ZM10.8847 8.33333H13.0617V9.58333H10.8847V8.33333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7555 17.5L2.61234 15.8333V4.16667L11.7555 2.5V17.5Z",
    fill: "url(#paint0_linear_851_6742)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32901 12.9173L7.27972 11.0173C7.24054 10.9465 7.197 10.8173 7.15781 10.6257H7.1404C7.11863 10.7173 7.07509 10.8507 7.00107 11.034L5.94743 12.9173H4.31036L6.2522 10.0007L4.47581 7.08398H6.14771L7.01849 8.83398C7.08815 8.97148 7.14911 9.13815 7.20135 9.32565H7.21877C7.2536 9.21315 7.31455 9.04232 7.41034 8.81732L8.38126 7.08398H9.90948L8.08084 9.97565L9.96172 12.9173H8.33337H8.32901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7143 17.6471H15.2857V14.1176H13L17 10L21 14.1176H18.7143V17.6471Z",
    fill: "#F58120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 18.8235H13V20H21V18.8235Z",
    fill: "#F58120"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_851_6742",
    x1: 2.61234,
    y1: 10,
    x2: 11.7555,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21AD64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088242"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_851_6742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.8987,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelUpload);
export default __webpack_public_path__ + "static/media/ExcelUpload.ee6c1cd2243e2322f3269c9412936ea6.svg";
export { ForwardRef as ReactComponent };